module.exports = __webpack_public_path__ + "img/4.cfde4af1.png";